import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Supplier } from 'entities/Property/model/types/PropertySchema';
import { Vendor } from 'entities/Vendors';
import {
    getVendorProductOrderingStatusStyles,
    getVendorProductOrderingStatusText,
} from 'entities/Vendors/model/lib/productSourcingUtil';

interface VendorAccountStatusPillProps {
    vendor: Vendor | Supplier;
    showDashOnEmptyStatus?: boolean;
}

function resolveVendorStatus(vendor: Vendor | Supplier): string | null {
    if ('operationsAccountStatus' in vendor && vendor.operationsAccountStatus) {
        return vendor.operationsAccountStatus;
    }
    if (
        'operationsActivationStatus' in vendor &&
        vendor.operationsActivationStatus
    ) {
        return vendor.operationsActivationStatus;
    }
    return null;
}

export const VendorAccountStatusPill = (
    props: VendorAccountStatusPillProps,
) => {
    const { vendor, showDashOnEmptyStatus = false } = props;
    const { t } = useTranslation();

    const status = resolveVendorStatus(vendor);

    const statusStyles = getVendorProductOrderingStatusStyles(status);

    const statusText = getVendorProductOrderingStatusText(t, status, '-');

    if (statusText === '-') {
        if (showDashOnEmptyStatus) {
            return <Box>{'-'}</Box>;
        }

        return null;
    }

    return (
        <Box
            sx={{
                backgroundColor: statusStyles.backgroundColor,
                color: statusStyles.color,
                borderRadius: '22px',
                padding: '4px 8px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
            }}
        >
            <Typography
                typography="openSans.body2Medium"
                sx={{
                    fontSize: '12px',
                    fontWeight: 700,
                    lineHeight: '16px',
                }}
            >
                {statusText}
            </Typography>
        </Box>
    );
};
